import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Order } from 'src/app/models/order.model';
import { OrderService } from 'src/app/services/order.service';
import { NewListAction } from 'src/app/store/actions/shopping.actions';
import { AppState } from 'src/app/store/models/app-state.model';
import { MatDivider } from "@angular/material/divider";
import { MatTableModule } from '@angular/material/table';
import { MatCard } from "@angular/material/card";

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss'],
  imports: [MatDivider, MatTableModule, MatCard]
})
export class PaymentSuccessComponent implements OnInit, OnDestroy {
  private routeSub!: Subscription;
  orderId: string = "";
  completedOrder: Order = new Order();
  displayedColumns: string[] = ['Description', 'Appointment Type', 'Rate', 'Quantity Requested', 'Total Cost'];


  constructor(
    private activatedRoute: ActivatedRoute,
    private orderService: OrderService,
    private store: Store<AppState>,
  ) { }

  ngOnDestroy(): void {
    this.routeSub.unsubscribe();
  }

  ngOnInit() {
    this.store.dispatch(new NewListAction([]));
    const emptyMap = new Map();
    this.routeSub = this.activatedRoute.params.subscribe(params => {
      this.orderId = params['id'];
      this.orderService.get([this.orderId], emptyMap).subscribe((order) => {
        this.completedOrder = order;
      })
    });
  }

}
